__webpack_require__.p = "//asset.nysaa.com/static/";